import { IconStores } from 'components/Shared/Icon/themes/BGH-RD3/iconStores';
import { IconArrow } from 'components/Shared/Icon/themes/BGH-RD3/iconArrow';
import styles from './styles.scss';
import { StoresModel } from 'models/StoresModel';
import { Button } from 'components/Button';
import { Store as StoreModel } from 'models/Store';
import cn from 'classnames';
import { headerConnect as connect } from 'components/Shared/connect';
import { openStoresDropDown, closeStoresDropDown } from 'components/StoreInfo/actions';
import { StoresMergedProps, StoresOwnProps } from 'components/StoreInfo/props';
import { rm, NO_ELEMENT, hasElements } from 'utils';
import { selectBlackFridayStatus } from 'components/Header/themes/BGH/selector';
import { useSelector } from 'react-redux';

interface StoreProps extends StoreModel {
  appearance?: 'primary' | 'tertiary';
  className?: string;
  onClick?: () => void;
}

export const Store = ({
  location,
  todaysOpeningHours,
  url,
  className,
  appearance = 'primary',
  onClick
}: StoreProps) => (
  <Button
    appearance={appearance}
    size="medium"
    className={cn(styles.storeLink, className)}
    href={url}
    onClick={onClick}
  >
    <span className={styles.location}>{location}</span>
    <span className={styles.openingHours}>
      <span className={styles.time}>
        {rm('stores_info_opening_hours_today', todaysOpeningHours)}
      </span>
      <IconArrow size="small" />
    </span>
  </Button>
);

const DropDown = ({ stores }: Pick<StoresModel, 'stores'>) => {
  const blackFridayIsActive = useSelector(selectBlackFridayStatus);
  return (
    <ul className={cn(styles.dropdown, { [styles.blackFriday]: blackFridayIsActive })}>
      {stores.map(store => (
        <li className={styles.store} key={store.url}>
          <Store {...store} className={styles.dropdownStoreLink} appearance="tertiary" />
        </li>
      ))}
    </ul>
  );
};

const _StoresInfo = ({
  url,
  stores,
  isOpen,
  openStoresDropDown,
  closeStoresDropDown,
  className
}: StoresMergedProps) =>
  hasElements(stores) ? (
    <div
      className={cn(styles.stores, className)}
      onMouseEnter={openStoresDropDown}
      onMouseLeave={closeStoresDropDown}
    >
      <IconStores className={styles.icon} />
      <a className={styles.tagline} href={url}>
        {rm('visit_our_stores')}
      </a>
      <IconArrow className={styles.icon} size="small" appearance="flip-90" />
      {isOpen && <DropDown stores={stores} />}
    </div>
  ) : (
    NO_ELEMENT
  );

export const StoresInfo = connect<StoresMergedProps, StoresOwnProps>(
  state => ({
    ...state.stores
  }),
  dispatch => ({
    openStoresDropDown: () => dispatch(openStoresDropDown()),
    closeStoresDropDown: () => dispatch(closeStoresDropDown())
  })
)(_StoresInfo);

export const MobileStoresInfo = () => NO_ELEMENT;
